import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  updateClient,
  addClient,
  clearClient,
} from '../../../actions/adminAction';
import { setAlert } from '../../../actions/alertAction';
import Alert from '../../../layouts/Alert';

const ClientForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const client = useSelector((state) => state.admin.client);
  const clientLoading = useSelector((state) => state.admin.clientLoading);

  const [formData, setFormData] = useState({
    id: client === null ? '' : client.id !== undefined ? client.id : '',
    title:
      client === null ? '' : client.title !== undefined ? client.title : '',
  });

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const { title, id } = formData;

  const onSubmit = (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    if (location.pathname.includes('add')) {
      console.log('add');
      dispatch(addClient(formData)).then(() => {
        setFormData({ id: '', title: '' });
        navigate('/admin/clients');
      });
    } else if (location.pathname.includes('edit')) {
      console.log('edit');
      dispatch(updateClient(id, formData));
      navigate('/admin/clients');
      dispatch(clearClient());
    }
  };

  useEffect(() => {
    if (client == null && location.pathname.includes('edit')) {
      navigate('/admin/clients');
    }
  }, [client]);

  return (
    <div className='admin-card px-sm-5 py-sm-4 p-2 me-0 mt-0 mb-0 text-main'>
      <div className='mb-2 '>
        <h6 className='text-main my-3'>Admin / Companies / Company</h6>
        <div className='d-sm-flex  w-100 align-items-center justify-content-between'>
          <div className='d-flex mb-2 mb-sm-0 align-items-center'>
            <div
              className='admin-back mx-2  rounded-circle border border-2 d-flex align-items-center justify-content-center'
              onClick={() => {
                navigate(-1);
              }}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                fill='currentColor'
                className='bi bi-arrow-left-short'
                viewBox='0 0 16 16'
              >
                <path
                  fillRule='evenodd'
                  d='M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z'
                />
              </svg>
            </div>
            <h4 className='m-0'>
              {location.pathname.includes('add') ? 'Add Company' : 'Edit'}
            </h4>
          </div>
        </div>
      </div>
      <form
        className='card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 admin-list mb-2 h-max-content'
        onSubmit={(e) => onSubmit(e)}
      >
        <Alert />
        <div className='row'>
          <div className='col-lg-4 col'>
            <div className='mb-3'>
              <h5 className='text-main fw-bold'>Title</h5>
              <input
                type='text'
                className='form-control rounded admin-list text-main'
                id='title'
                placeholder='Enter title...'
                required
                value={title}
                onChange={(e) => onChange(e)}
              />
            </div>
          </div>
        </div>

        <div className='d-flex align-items-center justify-content-center'>
          <button
            type='submit'
            className='admin-list-btn-secondary text-main btn-block btn px-5'
          >
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default ClientForm;
